<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 预警系统</el-breadcrumb-item>
                <el-breadcrumb-item>后端Api接口</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='14'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item prop='dictType' style='margin-bottom: 0'>
                                <el-input
                                    size='mini'
                                    v-model='queryParams.url'
                                    clearable
                                    placeholder='请输入后端接口地址'
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select size='mini' v-model='queryParams.apiWarningLevel' placeholder='请选择'>
                                    <el-option
                                        v-for='item in alterWarningLevelList'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='10'>
                        <el-row class='mb8'>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-plus'
                                    plain
                                    size='mini'
                                    type='primary'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-delete-solid'
                                    plain
                                    size='mini'
                                    type='warning'
                                    :disabled='!batchDeleteStatus'
                                    @click='handleBatchDelete'
                                >批量删除
                                </el-button>
                            </el-col>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-download'
                                    plain
                                    size='mini'
                                    type='warning'
                                    @click='handleImport'
                                >导入
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='apiInfoList'
                      @selection-change='handleSelectionChange'>
                <el-table-column align='center' type='selection' width='55' />
                <el-table-column align='center' label='接口名称' prop='name' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='地址' prop='url' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='请求方法' prop='method' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='类型' prop='apiRequestType'>
                    <template slot-scope='scope'>
                        <el-tag size='mini' :type='getRequestType(scope.row.apiRequestType)'>
                            {{ scope.row.apiRequestType }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='预警级别' prop='apiWarningLevel'>
                    <template slot-scope='scope'>
                        <el-tag size='mini' :type='getWarningLevelType(scope.row.apiWarningLevel)'>
                            {{ getWarningLevelMsg(scope.row.apiWarningLevel) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='参数类型' prop='contentType' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='参数' prop='parameter' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='诊断成功字段'
                                 prop='assertSuccessFieldName' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='诊断成功值'
                                 prop='assertSuccessFieldValue' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='创建时间' prop='createTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                        <el-button
                            icon='el-icon-monitor'
                            size='mini'
                            type='text'
                            @click='handleApiTest(scope.row)'
                        >测试
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :before-close='cancel' :visible.sync='open' append-to-body width='500px'>
                <el-form label-position='right' ref='form' label-width='100px'>
                    <el-form-item label='Api接口地址' prop='url'>
                        <el-input size='mini' v-model='currentApiInfo.url' placeholder='请输入接口地址' />
                    </el-form-item>
                    <el-form-item label='接口名称' prop='url'>
                        <el-input size='mini' v-model='currentApiInfo.name' placeholder='请输入接口名称' />
                    </el-form-item>
                    <el-form-item label='请求类型' prop='url'>
                        <el-select size='mini' v-model='currentApiInfo.apiRequestType' placeholder='请选择'>
                            <el-option
                                v-for='item in apiRequestTypeList'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='预警级别' prop='url'>
                        <el-select size='mini' v-model='currentApiInfo.apiWarningLevel' placeholder='请选择'>
                            <el-option
                                v-for='item in alterWarningLevelList'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='接口参数类型' prop='url'>
                        <el-select size='mini' v-model='currentApiInfo.contentType' placeholder='请选择'>
                            <el-option
                                v-for='item in contentTypeList'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='请求方法' prop='url'>
                        <el-select size='mini' v-model='currentApiInfo.method' placeholder='请选择'>
                            <el-option
                                v-for='item in requestMethod'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='诊断成功字段名称' prop='url'>
                        <el-input size='mini' v-model='currentApiInfo.assertSuccessFieldName'
                                  placeholder='请输入白名单地址' />
                    </el-form-item>
                    <el-form-item label='诊断成功字段值' prop='url'>
                        <el-input size='mini' v-model='currentApiInfo.assertSuccessFieldValue'
                                  placeholder='请输入白名单地址' />
                    </el-form-item>
                    <el-form-item label='接口参数' prop='url'>
                        <el-input type='textarea' v-model='currentApiInfo.parameter'
                                  :autosize='{ minRows: 2, maxRows: 6}' />
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
            
            <!--导入连接-->
            <el-dialog
                :visible='openImportDialog'
                :visible.sync='openImportDialog'
                title='导入后端Api'
                width='30%'>
                <div class='tree'>
                    <el-row :gutter='20'>
                        <el-col :span='18'>
                            <el-input size='mini' placeholder='请输入过滤条件' v-model='treeFilterText' />
                        </el-col>
                        <el-col :span='6'>
                            <el-button @click='handleChoseAll' size='mini' type='primary'>全选</el-button>
                        </el-col>
                    </el-row>
                    <el-tree
                        :data='apiInfoTreeOptions'
                        ref='tree'
                        :filter-node-method='handleFilterNode'
                        :default-checked-keys='defaultCheckUrlList'
                        :default-expand-all='false'
                        :props='defaultProps'
                        check-on-click-node
                        highlight-current
                        node-key='value'
                        show-checkbox
                        :render-content='handleRenderContent'
                        @check='handleNodeClick'
                        @node-click='handleNodeClick'>
                    </el-tree>
                </div>
                
                <template slot='footer'>
                    <el-button plain @click='openImportDialog = !openImportDialog'>取消</el-button>
                    <el-button plain type='primary' @click='handleImportSubmit'>提交</el-button>
                </template>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { getSwaggerApiInfo, getSwaggerResources } from '@/components/api/doc';
import { EnumBackEndApiPrefix } from '@/constant/enums';
import { deleteWhiteUrl, insertWhiteUrl, queryWhiteUrlList } from '@/components/api/white';
import { deepCopy } from '@/utils/object';
import { deleteApiInfo, insertApiInfo, queryApiInfoList, updateApiInfo } from '@/components/api/Api/BackendApi';
import { monitorCustomApi, queryManualApiTestResult } from '@/components/api/Monitor/Monitor';
import { copyContent } from '@/utils/string/cottonPlugin';

export default {
    name: 'Dict',
    data() {
        return {
            alterWarningLevelList: [
                {
                    label: '一级预警',
                    value: 'HIGH'
                },
                {
                    label: '二级预警',
                    value: 'MIDDLE'
                },
                {
                    label: '三级预警',
                    value: 'LOW'
                }
            ],
            apiRequestTypeList: [
                {
                    label: '增加操作',
                    value: 'INSERT'
                },
                {
                    label: '删除操作',
                    value: 'DELETE'
                },
                {
                    label: '修改操作',
                    value: 'UPDATE'
                },
                {
                    label: '查询操作',
                    value: 'QUERY'
                }
            ],
            contentTypeList: [
                {
                    label: 'JSON',
                    value: 'JSON'
                },
                {
                    label: 'FORM_URL_ENCODED',
                    value: 'FORM_URL_ENCODED'
                },
                {
                    label: 'FORM_DATA',
                    value: 'FORM_DATA'
                }
            ],
            requestMethod: [
                {
                    label: 'POST',
                    value: 'POST'
                },
                {
                    label: 'GET',
                    value: 'GET'
                }
            ],
            defaultProps: {
                children: 'children',
                label: 'label',
                value: 'value',
                url: 'url'
            },
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            whiteUrlList: [],
            apiInfoList: [],
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                id: undefined,
                url: undefined,
                apiWarningLevel: undefined
            },
            updateStatus: false,
            currentApiInfo: {},
            currentWhiteUrl: {},
            apiInfoTreeOptions: [],
            openImportDialog: false,
            checkedUrlList: [],
            defaultCheckUrlList: [],
            swaggerApiInfoList: [],
            treeFilterText: undefined,
            apiTestResultVisible: false,
            alterWarningNoticeUrl: ''
        };
    },
    watch: {
        treeFilterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    computed: {
        getRequestType() {
            return (type) => {
                switch (type) {
                    case 'INSERT':
                        return 'success';
                    case 'QUERY':
                        return 'info';
                    case 'UPDATE':
                        return 'warning';
                    case 'DELETE':
                        return 'danger';
                }
            };
        },
        getWarningLevelType() {
            return (level) => {
                switch (level) {
                    case 'HIGH':
                        return 'danger';
                    case 'MIDDLE':
                        return 'warning';
                    case 'LOW':
                        return 'info';
                }
            };
        },
        getWarningLevelMsg() {
            return (level) => {
                switch (level) {
                    case 'HIGH':
                        return '一级预警';
                    case 'MIDDLE':
                        return '二级预警';
                    case 'LOW':
                        return '三级预警';
                }
            };
        }
    },
    created() {
        this.getList();
    },
    methods: {
        handleCopyNoticeUrl() {
            copyContent(this.alterWarningNoticeUrl);
        },
        handleChoseAll() {
            this.apiInfoTreeOptions.forEach((api, index) => {
                if (api.children) {
                    api.children.forEach((child, childIndex) => {
                        if (!child.disabled) {
                            let arr = this.$refs.tree.getCheckedKeys();
                            arr.push(child.url);
                            this.$refs.tree.setCheckedKeys(arr);
                        }
                    });
                }
            });
        },
        handleFilterNode(value, data) {
            if (!value) return true;
            return data.url.indexOf(value) !== -1;
        },
        handleRenderContent(h, { node, data, store }) {
            if (!data.children) {
                return (<el-tooltip className='item' effect='dark' placement='right'>
                    <template slot='content'>{data.url}</template>
                    <span>{node.label}</span></el-tooltip>);
            }
            return (<span>{node.label}</span>);
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleImportSubmit() {
            let checkApiArr = [];
            this.$refs.tree.getCheckedKeys().forEach(api => {
                if (api !== undefined) {
                    checkApiArr.push(api);
                }
            });
            this.checkedUrlList = [];
            this.checkedUrlList = checkApiArr;
            if (!this.checkedUrlList || this.checkedUrlList.length === 0) {
                message.warning('请选择后端接口');
                return;
            }
            let checkedUrlListTemp = this.checkedUrlList;
            let apiInfoListTemp = this.swaggerApiInfoList;
            let dom = this;
            this.$modal.confirm(`你确定要添加 ${this.checkedUrlList.length} 个接口么?`).then(function() {
                checkedUrlListTemp.forEach((api, index) => {
                    apiInfoListTemp.forEach(info => {
                        if (api === info.url) {
                            let name = '';
                            if (info.tag) {
                                name = info.tag;
                            }
                            if (info.label) {
                                if (name.length > 0) {
                                    name = name + '-' + info.label;
                                } else {
                                    name = info.label;
                                }
                            }
                            if (name.length === 0) {
                                name = api;
                            }
                            insertWhiteUrl({ url: api });
                            if (index === checkedUrlListTemp.length - 1) {
                                message.success('批量添加成功');
                                dom.getList();
                                dom.handleImport();
                                dom.openImportDialog = false;
                            }
                        }
                    });
                });
            });
        },
        handleNodeClick(data) {
            // 如果执行的是父节点
            // if (data.children) {
            //     data.children.forEach(son => {
            //         if (!son.disabled) {
            //             const uri = son.url;
            //             if (!this.checkedUrlList.includes(uri)) {
            //                 this.checkedUrlList.push(uri);
            //             }
            //         }
            //     });
            // } else {
            //     const uri = data.value;
            //     if (!this.checkedUrlList.includes(uri)) {
            //         this.checkedUrlList.push(uri);
            //     }
            // }
        },
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            queryApiInfoList(this.queryParams).then(response => {
                    if (response.code === 200) {
                        this.apiInfoList = response.data.result;
                        this.queryParams.total = response.data.total;
                        this.loading = false;
                        this.queryParams.pageNum = response.data.pageNum;
                    } else {
                        this.loading = false;
                    }
                }
            );
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
            this.currentWhiteUrl = {};
        },
        // 表单重置
        reset() {
        
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {};
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = '增加后端接口';
            this.updateStatus = false;
            this.currentApiInfo = {};
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            this.$modal.confirm(`是否删除 ${idList.length} 条数据?`).then(function() {
                return deleteWhiteUrl(idList);
            }).then(result => {
                if (result.code === 200) {
                    message.success('删除成功');
                    obj.getList();
                }
            });
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            this.open = true;
            this.title = '修改Api接口信息';
            this.updateStatus = true;
            this.currentApiInfo = deepCopy(row);
        },
        setDefaultProperties() {
            if (!this.currentApiInfo.method) {
                this.currentApiInfo.method = 'POST';
            }
            
            if (!this.currentApiInfo.contentType) {
                this.currentApiInfo.contentType = 'JSON';
            }
            
            if (!this.currentApiInfo.apiWarningLevel) {
                this.currentApiInfo.apiWarningLevel = 'LOW';
            }
            if (!this.currentApiInfo.assertSuccessFieldName) {
                this.currentApiInfo.assertSuccessFieldName = 'code';
            }
            if (!this.currentApiInfo.assertSuccessFieldValue) {
                this.currentApiInfo.assertSuccessFieldValue = '200';
            }
            
        },
        /** 提交按钮 */
        submitForm: function() {
            console.log(this.currentApiInfo);
            this.setDefaultProperties();
            if (!this.currentApiInfo.apiRequestType) {
                message.warning('请选择接口请求类型');
                return;
            }
            if (this.updateStatus) {
                updateApiInfo(this.currentApiInfo).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            } else {
                if (!this.currentApiInfo.url) {
                    message.warning('接口地址不能为空');
                    return;
                }
                if (!this.currentApiInfo.parameter) {
                    message.warning('接口参数不能为空');
                    return;
                }
                insertApiInfo(this.currentApiInfo).then(result => {
                    if (result.code === 200) {
                        message.success('添加成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除Url为"' + row.url + '"的数据项？').then(function() {
                return deleteApiInfo({ id: row.id });
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        // 执行接口测试
        handleApiTest(row) {
            message.success('正在执行Api接口测试');
            monitorCustomApi({ idList: [row.id] }).then(result => {
                if (result.code === 200) {
                    message.success('接口测试成功，正在获取测试结果');
                    let obj = this;
                    let time = setInterval(function() {
                        queryManualApiTestResult().then(result => {
                            if (result.code === 200) {
                                clearInterval(time);
                                message.success('获取测试结果成功');
                                obj.$notify({
                                    type: 'success',
                                    title: '测试结果',
                                    message: `测试结果请点击\n${result.data} 进行查看`,
                                    showClose: true,
                                    onClick: () => copyContent(result.data)
                                    
                                });
                            }
                        });
                    }, 200);
                }
            });
        },
        // 获取模块信息
        async getModuleInfo() {
            let moduleList = [];
            for (const apiPrefix of EnumBackEndApiPrefix) {
                const result = await getSwaggerResources(apiPrefix);
                if (result.data) {
                    for (let i = 0; i < result.data.length; i++) {
                        result.data[i].url = `/${apiPrefix}${result.data[i].url}`;
                        moduleList.push(result.data[i]);
                    }
                }
            }
            return moduleList;
        },
        // 通过模块信息，获取api接口信息
        async getApiInfo(moduleList) {
            let swaggerApiInfoList = [];
            for (let i = 0; i < moduleList.length; i++) {
                const apiInfo = await getSwaggerApiInfo(moduleList[i].url);
                let pathList = Array.of(apiInfo.data.paths);
                let moduleApiInfoMap = new Map();
                for (let j = 0; j < pathList.length; j++) {
                    // 获取api请求uri
                    for (const apiPath in pathList[j]) {
                        // 获取该api的请求方法
                        for (const method in pathList[j][apiPath]) {
                            // 获取api的数据
                            let tag = pathList[j][apiPath][method]['tags'][0] ? pathList[j][apiPath][method]['tags'][0] : apiPath;
                            let description = pathList[j][apiPath][method]['summary'] ? pathList[j][apiPath][method]['summary'] : apiPath;
                            let upperMethod = method.toUpperCase();
                            let info = {
                                uri: apiPath,
                                method: upperMethod,
                                tag: tag,
                                description: description
                            };
                            if (!moduleApiInfoMap.get(pathList[j][apiPath][method]['tags'][0])) {
                                moduleApiInfoMap.set(pathList[j][apiPath][method]['tags'][0], []);
                            }
                            moduleApiInfoMap.get(pathList[j][apiPath][method]['tags'][0]).push(info);
                        }
                    }
                }
                swaggerApiInfoList.push(moduleApiInfoMap);
            }
            return swaggerApiInfoList;
        },
        async handlePackApi() {
            this.apiInfoTreeOptions = [];
            this.swaggerApiInfoList = [];
            this.openImportDialog = true;
            let moduleList = await this.getModuleInfo();
            let swaggerApiInfoList = await this.getApiInfo(moduleList);
            for (let i = 0; i < swaggerApiInfoList.length; i++) {
                for (const [tag, paths] of swaggerApiInfoList[i]) {
                    let parentOption = {
                        label: tag,
                        url: tag,
                        disabled: false,
                        children: []
                    };
                    for (let j = 0; j < paths.length; j++) {
                        let sonOption = {
                            label: paths[j]['description'],
                            tag: paths[j]['tag'],
                            disabled: false,
                            value: `${paths[j]['method']}:${paths[j]['uri']}`,
                            url: `${paths[j]['method']}:${paths[j]['uri']}`
                        };
                        this.swaggerApiInfoList.push({
                            url: `${paths[j]['method']}:${paths[j]['uri']}`,
                            tag: paths[j]['tag'],
                            label: paths[j]['description'],
                            value: `${paths[j]['method']}:${paths[j]['uri']}`,
                            disabled: false
                        });
                        parentOption.children.push(sonOption);
                    }
                    this.apiInfoTreeOptions.push(parentOption);
                }
            }
            
            return this.apiInfoTreeOptions;
        },
        /** 导入后端接口 */
        async handleImport() {
            this.checkedUrlList = [];
            this.defaultCheckUrlList = [];
            let apiTreeOptions = await this.handlePackApi();
            let whiteUrlResult = await queryWhiteUrlList({ pageSize: 1000000 });
            let queryWhiteUrlResultList = whiteUrlResult.data.result;
            // 已经添加的api添加禁用标识
            this.apiInfoTreeOptions.forEach((parent, index) => {
                if (!parent.children) {
                    return;
                }
                let children = parent.children;
                this.apiInfoTreeOptions[index].children = [];
                children.forEach((son, indexSon) => {
                    this.apiInfoTreeOptions[index].children.push(son);
                    queryWhiteUrlResultList.forEach(whiteUrl => {
                        if (son.url === whiteUrl.url) {
                            son.disabled = true;
                            this.defaultCheckUrlList.push(son.value);
                            this.apiInfoTreeOptions[index].children[indexSon].disabled = true;
                        }
                    });
                });
            });
        }
        
        
    }
};
</script>
<style>
.el-tree {
    min-width: 100%;
    display: inline-block;
}

.tree {
    overflow: auto;
    max-height: 60vh;
}
</style>